
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getHomePotentialHistory } from '@/apis/index';
import { jumpBy2804, autoColor } from '@/utils/tools';
import { STAT } from '@/config/config';
import allLink from '@/config/url';
@Component
export default class GuideCard extends Vue {
  // 卡片类型
  @Prop() private type!: string;
  @Prop() private upspaceBannerImg!: string;
  @Prop() private yhybBannerImg!: string;
  rate = '';
  color = '';
  get cardInfo() {
    // 卡片展示信息
    const { rate, color } = this;
    const info = {
      shangzhang: {
        title: '进阶功能推荐',
        name: '研报<span></span>上涨潜力<div></div>',
        tips: `近2个交易日选出6只股票，前3只股票平均收益率<span style="color: ${color}">${rate}</span>`,
        stat: `${this.$route.name === 'rank' ? STAT.rank : STAT.homeRecommend}.szql`,
      },
      yihao: {
        title: '进阶功能推荐',
        name: '脱水<span></span>壹号研报<div></div>',
        tips: '强势脱水归纳整理，免去费时筛选，一天这一篇就够了',
        stat: `${STAT.homeRecommend}.yhyb`,
      },
    };
    return info[this.type];
  }
  toPage() {
    // 跳转到对应地址 shangzhang上涨空间 yihao壹号研报
    const url = {
      shangzhang: allLink.upSpace,
      yihao: allLink.yihao,
    };
    window.hxmClickStat(this.cardInfo.stat);
    jumpBy2804(url[this.type]);
  }
  getData() {
    if (this.rate) {
      // 避免组件更新导致重复请求
      return;
    }
    // 获取上涨空间数据
    getHomePotentialHistory({}).then(res => {
      let rate: string | number = 0;
      // 获取前三条
      res.data.list.slice(0, 3).forEach(element => {
        rate += element.firstZdf;
      });
      // 格式化数据
      rate = (rate / 3).toFixed(2);
      // 获取数据
      this.rate = rate >= '0' ? `+${rate}%` : `${rate}%`;
      this.color = autoColor(this.rate);
    });
  }
  mounted() {
    if (this.type === 'shangzhang') {
      // 上涨空间类型需要获取
      this.getData();
    }
  }
}
